import { Button, styled } from '@mui/material'

const ButtonHeader = styled(Button)(({ theme }) => ({
  color: theme.palette.grey[50],
  textTransform: 'capitalize',
  fontWeight: 400,
  fontSize: 16,
  padding: '12px 15px',
  '&:hover, &.active': {
    backgroundColor: 'rgb(255, 255, 255, 0.2)',
    marginTop: '-1px'
  },
  '&.active .MuiTouchRipple-root': {
    borderTop: '3px solid',
    borderColor: theme.palette.primary.dark
  },
  '& svg': {
    color: `${theme.palette.grey[50]} !important`
  },
  [theme.breakpoints.up('md')]: {
    borderRadius: '0px 0px 0px 10px'
  },
  [theme.breakpoints.down('sm')]: {
    padding: '12px 95px',
    width: '100px',
    borderRadius: '0px 0px 0px 10px',
  }
}))

export default ButtonHeader
